import abi from './abi';
const config = {
  baseUrl: '/',
  // API_URL: 'http://localhost:8448/cp/api',
  // imageUrl: 'http://localhost:8448/uploads/',

  API_URL: 'https://utxapp.espsofttech.org/cp/api',
  imageUrl: 'https://utxapp.espsofttech.org/uploads/',

  contractAddress: '0x47af701dea5D86C5A2BE7d3C165604aeF5A72d10',
  contractABI: abi.contractABI,
  usdContractABI: abi.usdContractABI,
  ERC20ABI: abi.ERC20ABI,
  chainId: '0x61',
};

export default config;
